<script>
import Vue from 'vue'
import QuickShortcuts from "@/components/QuickShortcuts";
import QuickStats from "@/components/QuickStats";
import DailytInfo from "@/components/DailytInfo";
import CatalogList from "@/components/catalog-list"
Vue.component("CatalogList", CatalogList)
Vue.component("QuickShortcuts", QuickShortcuts)
Vue.component("QuickStats", QuickStats)
Vue.component("DailytInfo", DailytInfo)

import OffersApi from "@/services/offers-api";
import OrdersApi from "@/services/orders-api";
import ExchangeApi from "@/services/exchange-api";

import Swal from "sweetalert2";

export default {
  compenents: {CatalogList, QuickShortcuts, QuickStats},
    props: {
    selectedSupplier: {
      type: Number,
    },

    isHomePage : {
      type: Boolean,
      default: false
    },

    isGroupedPromotions : {
      type: Boolean,
      default: false
    },

    isActiveOffer : {
      type: Boolean,
      default: true
    },
    
    before : {
      type: String,
      default:null
    },
    after : {
      type: String,
      default:null
    },

    selectedPromotionParam : {
      type: Object,
      default: () => {}
    },
  },
    data() {
    return {

      isAdmin:null,

      offerPageModelMain: {currentPage : 1, perPage : 50, totalRows: 0},
      offersList: [],
      showModal: false,
      consolidatedPreOrderTotalQty: null,
      isOffersTableBusy: false,
      selectedPromotion:null,
      promotionRules : [],
      rotatingOffersList: [],

      isAnnouncmentsTableBusy:false,
      othersAnnouncmentsList:[],
      pageMain: {currentPage : 1, perPage : 4, totalRows: 0},

      showNewExchangeModal: false,

      showExchangeModal: false,
      selectedExchange: null,

      showCustomersListModal: false,
      customersInPromotionList: [],
      customersInPromotionFields: [   
                    { key:"name", label: "",   sortable: false, thClass:"text-center align-middle", tdClass:"font-weight-bold align-middle text-primary"},
                    { key:"city", label: "",   sortable: false ,thClass:"text-center align-middle", tdClass:" align-middle",},
                    { key:"address", label: "",   sortable: false,thClass:"text-center align-middle", tdClass:"align-middle",},
                ],

    }
      },
   
    mounted(){
      if(!this.isHomePage){
            this.getOffers()
      }
      if(this.isHomePage){
        this.getRotatingOffers();
        this.getOthersAnnoucments();
      }

      this.isAdmin = sessionStorage.getItem("userr") == 2;
  },
  methods : {

    setPromotion(offer){
      if(this.isAdmin){
        return
      }
      
      this.selectedPromotion=offer
      this.showModal=true
    },
  
    getOffers(){
      this.isOffersTableBusy = true;
      OffersApi.getOffers(true ,this.offerPageModelMain.currentPage,this.isHomePage ? 5 :this.offerPageModelMain.perPage,
      this.isHomePage ? null : this.selectedSupplier,this.isHomePage ? null : this.before,this.isHomePage ? null :this.after, null, this.isActiveOffer)
        .then(response => {
          this.offersList = response.list
          this.offerPageModelMain.totalRows = response.total;
          this.offerPageModelMain.currentPage = response.page;
          this.offerPageModelMain.perPage = response.pageSize;
          this.offerPageModelMain.pageSize = response.pageSize;
        })
        .finally(() => {
        this.isOffersTableBusy = false;
      })

    },

    getRotatingOffers(){
      this.isOffersTableBusy = true;
      OffersApi.getTopSupplierOffers(1, 5)
        .then(response => {
          this.rotatingOffersList = response.list
        })
        .finally(() => {
        this.isOffersTableBusy = false;
      })
    },

    updateOffers(isUpdate){
      if(isUpdate){
        if(!this.isHomePage){
              this.getOffers()
        }
        if(this.isHomePage){
          this.getRotatingOffers()
        }      
      }
    },

    getConsolidatedPreOrderTotalQty(promotionId) {
      this.consolidatedPreOrderTotalQty= null;
        OrdersApi.getConsolidatedPreOrderTotalQty(promotionId)
        .then(response => {
          this.consolidatedPreOrderTotalQty  = response;
        })
    },

    getOthersAnnoucments(){
       this.isAnnouncmentsTableBusy = true;
      ExchangeApi.getOthersAnnoucments(this.pageMain.currentPage, this.pageMain.perPage,this.productTitleFilter,this.expirationDateFiler,this.cityFilter ?this.cityFilter.id : null,this.sliderPriceFilter).then(
          result => {
            this.othersAnnouncmentsList = result.list
            this.pageMain.totalRows = result.total;
            this.pageMain.currentPage = result.page;
            this.pageMain.perPage = result.pageSize;
            this.pageMain.pageSize = result.pageSize;
        })
        .finally(() => {
          this.isAnnouncmentsTableBusy = false;
      })
    },

    addNewExchange(){
      this.selectedExchange={id:null,productTitle:'',price:0,description:'',expirationDate:'',stateForSwitch:true};
      this.showNewExchangeModal = true;
    },

    closeNewExchangeModal(){
        this.showNewExchangeModal=false
        this.selectedExchange=null;
     },

     saveAnnouncment(){
      ExchangeApi.saveAnnouncment(this.selectedExchange).then(
          (result)=>{
            if(result){
              this.getOthersAnnoucments();
              this.closeNewExchangeModal();
            }
          }
      )
    },

    showCustomersList(promotionId) {
      OffersApi.getCustomersInPromotion(promotionId).then(
          (result)=>{
            if(result){
              this.customersInPromotionList = result;
              this.showCustomersListModal = true;
            }
          }
      )
    },


    sendMail(promotionId, promotionTitle, customersCount) {

      var message = "Un e-mail d'annonce de l'offre sera envoyé à <strong>";
      message += customersCount ? customersCount + " officines ! </strong>" : "toutes les officines ! </strong>" ;
      
      Swal.fire({
        title: promotionTitle,
        html: message ,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, envoyer!"
      }).then(result => {
        if (result.value) {
          OffersApi.sendMail(promotionId)
          // .then(
          // (result)=>{
          //   if(result){
          //     this.customersInPromotionList = result;
          //     this.showCustomersListModal = true;
          //   }
          // }
          // )
        }

        
      });

    }
        

  } ,
  watch: {

    isActiveOffer : function(){
      this.getOffers()
    },

    selectedPromotionParam : function(){
      this.showModal = true;
      this.selectedPromotion=this.selectedPromotionParam
    },

    selectedSupplier : function(){
      this.getOffers()
    },
    before: function(){
       if((this.before  && this.after) || (!this.before  && !this.after) ){
         this.getOffers()
       }
      
    },
    after: function(){
        if((this.before  && this.after) || (!this.before  && !this.after) ){
          this.getOffers()
       }
      
    },
    showModal: function() {
      if(this.showModal && this.selectedPromotion){
        this.consolidatedPreOrderTotalQty= null;
        this.getConsolidatedPreOrderTotalQty(this.selectedPromotion.id) ;
      }else{
       this.$emit("closeModal")
      }
    }
  },
    
}

</script>
<template>
<div>
<!-- Offers not in home page -->
<div v-if="!this.isHomePage">

    <div class="row">
      <div
        v-for="offer in offersList"
        :key="offer.id"
        class="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-4"
      >
        <div class="offer-card text-center d-flex flex-column mx-md-4 mx-2">

          <!--div
            v-if="offer.isOldPromotion"
            class="offer-badge bg-secondary"
          >
            Terminée
          </div-->

          <div
            v-if="!offer.isOldPromotion && offer.isExpiringSoon"
            class="offer-badge bg-danger"
          >
            Expire bientôt
          </div>

          
          <div
            v-if="offer.isGroupedOrder"
            class="offer-type-badge bg-success"
          >
            Offre Groupée
          </div>

          <img
            :src="'/api/image/get/' + offer.logo" style="cursor:pointer;"
            class="offer-logo mx-auto mt-5"
            alt="logo"
            @click="setPromotion(offer)"
          />

          <!--h5 class="offer-name mt-1">
            {{ offer.supplierName}}
          </h5-->

          <p class="offer-note mt-3 text-primary font-weight-bold" @click="setPromotion(offer)" style="cursor:pointer;">
            {{ offer.title }}
          </p>


          <p class="offer-date mt-auto" v-if="offer.formattedendDate">
            Du
            <span class="font-weight-bold">
              {{ offer.formattedstartDate }}
            </span>
            au
            <span class="font-weight-bold">
              {{ offer.formattedendDate }}
            </span>
          </p>

          <p class="offer-date mt-auto " v-else>
            À partir du
            <span class="font-weight-bold">
              {{ offer.formattedstartDate }}
            </span>
          </p>


          

          <router-link v-if="offer.isOldPromotion"  
              :style="offer.isGroupedOrder ? 'cursor: pointer' : 'cursor:default'"
              :to="offer.isGroupedOrder ? { path: '/orders/order', query: { orderId: offer.id * -1 , showTransfer: true, showCashTotal: true}} : ''" >

              <b-button :variant="offer.isGroupedOrder ? 'primary' : 'white'" size="md" :class="offer.isGroupedOrder ? '' : 'text-white'" 
              class="font-size-16 text-uppercasee font-weight-bold mb-4 mt-auto mx-auto" 
              style="border-radius: 50px;"
              :style="offer.isGroupedOrder ? 'cursor: pointer' : 'cursor:default'"
                >
                      Commande Consolidée
              </b-button>

          </router-link>

          <b-button v-else-if="!isAdmin" variant="success" size="md" class="font-size-16 text-uppercase font-weight-bold mb-4 mt-auto mx-auto " style="border-radius: 50px;"
             @click="setPromotion(offer)">
                  Voir l'Offre
          </b-button>

          <div v-else-if="isAdmin" class="text-center d-md-table-cell d-none">
            <b-button 
              variant="danger" 
              class="font-weight-bold mr-2"
              @click="sendMail(offer.id, offer.title, offer.customersCount)"
            >
              <i class="fas fa-paper-plane mr-2" /> Envoyer Mail
            </b-button>

            <b-button 
              v-if="offer.customersCount"
              variant="outline-warning" 
              @click="showCustomersList(offer.id)" 
              class="font-weight-bold"
            >
              <i class="far fa-eye mr-2" /> 
              {{ offer.customersCount + ' Officines' }}
            </b-button>
          </div>
        </div>
      </div>
    </div>


  <div v-if="isOffersTableBusy" class="d-flex justify-content-center">
      <div class="spinner-border text-success" role="status">
          <span class=" sr-only">Chargement...</span>
      </div>
  </div>
  <span v-if="!isOffersTableBusy && !offersList.length " class="d-flex justify-content-center m-4 text-danger" >Aucune offre dans la liste</span>
  <!-- Pagination -->
  <div v-if="!this.isHomePage" class="row pt-3 mb-sm-4 mt-4">
      <div class="col-sm-8">
          <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
              <b-form-select @input="getOffers()"  v-model="offerPageModelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
              <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{offerPageModelMain.totalRows}} lignes</span></div>
          </div>
      </div>
      <div class="col-sm-4">
          <div class="dataTables_paginate paging_simple_numbers float-right">
              <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="offerPageModelMain.currentPage" :disabled="isOffersTableBusy" :per-page="offerPageModelMain.pageSize" :total-rows="offerPageModelMain.totalRows" @input="getOffers()" ></b-pagination>
              </ul>
          </div>
      </div>
  </div> 
  <!-- Fin Pagination  -->
</div>
<!-- End of Offers not in home page -->

<!-- Offers in home page -->
    <div v-if="this.isHomePage" class="row pt-2 pb-3 mt-2">
    <div v-if="this.isHomePage" class="row pt-3 pb-3 mt-4"></div>
    <div class="col-md-4 col-sm-6 col-12 pr-lg-2 pr-md-2 ">
      <div class="card h-100 border border-info">
        <div class="card-body" style="min-height:450px;">
          
          <div class="mb-2 d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-md-between">
            <h2 class="card-title text-primary text-uppercase mb-2 mb-md-0" style="font-size:20px;">
              Dernières Offres Actives
            </h2>
          </div>

          <hr class="mb-4" />



          <div v-if="isOffersTableBusy" class="d-flex justify-content-center">
            <div class="spinner-border text-success" role="status">
                <span class=" sr-only">Chargement...</span>
            </div>
          </div>

          <div class="mb-4">
            <div class="list-group pb-2"  v-for="offer in rotatingOffersList" :key="offer.id">
                <div  style="border:0px;">
                  <div class="media ">
                  
                    <!-- <img
                    class="rounded-circle avatar-sm "
                    v-bind:src="'/api/image/get/' + offer.logo"
                    data-holder-rendered="true"/> -->

                    <img class="d-none d-sm-inline" v-bind:src="'/api/image/get/' + offer.logo" alt style="height: auto;width: 80px;padding: 10px; cursor: pointer" @click="showModal = true;selectedPromotion=offer">
                                        
                    <div class="media-body mt-1 ml-2">
                      <h2 class="font-size-16">
                        <a href="javascript:void(0);" @click="showModal = true;selectedPromotion=offer" class="text-dark">{{offer.title}}</a>
                      </h2>
                      <!--div class="float-right">
                        <p :class="offer.type===0 ? 'text-warning mb-0' : 'text-primary mb-0'" style="font-weight:bold">
                          <i :class="offer.type===0 ? 'mdi mdi-calendar-clock font-size-18 mr-1 text-warning':'mdi mdi-calendar-multiple-check font-size-18 mr-1 text-primary'" ></i>
                        </p>

                      </div-->
                        <p v-if="offer.formattedendDate" class="text-muted mb-0">Du <span class="text-success font-weight-bold">{{offer.formattedstartDate}}</span> au <span class="text-danger font-weight-bold">{{offer.formattedendDate}}</span>, Offre publiée le {{offer.formattedPublishDate}} </p>
                        <p v-if="!offer.formattedendDate" class="text-muted mb-0">A partir du <span class="text-success font-weight-bold">{{offer.formattedstartDate}}</span>, Offre publiée le {{offer.formattedPublishDate}} </p>                 
                      </div>

                      <div class="text-right">
                        <b-button variant="success" style="border-radius: 12px;" @click="showModal = true;selectedPromotion=offer" >
                          Voir
                        </b-button>
                      </div>
                      
                  </div>
                </div>

            </div>

            <span v-if="!isOffersTableBusy && !rotatingOffersList.length " class="d-flex justify-content-center m-4 text-danger" >Aucune offre dans la liste</span>

          </div> 


          <div class=" mt-4 text-center">
            <b-button
              variant="outline-success"
              :to="{ path: '/promotions/list' }"
              class="font-weight-bold text-uppercase"
              style="letter-spacing: 1px;"
            >
              Voir toutes les offres
            </b-button>
          </div>
            

        </div>
      </div>
    </div>


      <!-- Echanges -->
    <div class="col-md-4 col-sm-6 col-12 pl-lg-3 pr-md-3 pl-0 pl-md-4 mt-sm-0 mt-4 mt-md-0 mt-lg-0">
      <div class="card ml-md-0 ml-sm-2 ml-0 mb-4 border border-info">
        <div class="card-body" style="min-height:300px;">
          <div class="mb-4" >
            <h2 class="card-titl text-primary text-uppercase" style="font-size:20px; margin: 0;">
              Annonces d'échanges Entre Pharmacies
            </h2>
          </div>

          

          <div v-if="isAnnouncmentsTableBusy" class="d-flex justify-content-center">
            <div class="spinner-border text-success" role="status">
                <span class=" sr-only">Chargement...</span>
            </div>
            </div>

            <div class="list-group"  v-for="othersAnnouncment in othersAnnouncmentsList" :key="othersAnnouncment.id">
              
              
                <div class="my-2">
                  <a href="javascript:void(0);" @click="showExchangeModal = true;selectedExchange=othersAnnouncment" class="text-dark">
                    <div class="row ">

                        <div class="col-12">
                          <h2 class="font-size-14 m-0">
                            {{othersAnnouncment.productTitle}}
                          </h2>
                          <!-- <h5 class="text-truncate font-size-12 text-secondary">{{othersAnnouncment.customerName}}, {{othersAnnouncment.customerCity}}</h5> -->
                        </div>

                        <!-- <div class="col-lg-6 col-md-6 col-12 text-right">
                          <h5 class="text-secondary font-size-12 pull-right text-lg-right text-left"><i>{{othersAnnouncment.formattedCreationDate}}</i></h5>
                        </div> -->
        
                    </div>

                    <div class="row font-size-12">

                        <div class="col-lg-6 col-md-6 col-12">
                          <div class="text-truncate  text-secondary">{{othersAnnouncment.customerName}}, {{othersAnnouncment.customerCity}}</div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-12">
                          <div class="text-secondary pull-right text-lg-right text-md-right text-left"><i>{{othersAnnouncment.formattedCreationDate}}</i></div>
                        </div>

                    </div>
                
                      <!--h2 class="font-size-18">
                        <a href="javascript:void(0);" @click="showModal = true;selectedPromotion=offer" class="text-dark">{{othersAnnouncment.productTitle}}</a>
                      </h2>

                      <h5 class="mb-3 text-truncate font-size-12 badge badge-primary"><i class="fas fa-plus mr-2"/>{{othersAnnouncment.customerName}}</h5-->

                    </a>
                </div>
                

            </div>
            <span v-if="!isAnnouncmentsTableBusy && !othersAnnouncmentsList.length " class="d-flex justify-content-center m-4 text-danger" >Aucune annonce dans la liste</span>
          </div>

          <div class="card-footer" style="    background-color: white; padding-bottom: 0px;padding-top: 0px;">
                <!-- Pagination -->
              <div class="row pt-2 pb-3">
                  <div class="col-sm-8">
                      <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                          <b-form-select @input="getOthersAnnoucments()"  v-model="pageMain.perPage" size="sm" style="width: 60px" :options="[4]"></b-form-select>
                          <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pageMain.totalRows}} annonces</span></div>
                      </div>
                  </div>
                  <div class="col-sm-4">
                      <div class="dataTables_paginate paging_simple_numbers float-right">
                          <ul class="pagination pagination-rounded mb-0">
                          <b-pagination v-model="pageMain.currentPage" :disabled="isAnnouncmentsTableBusy" :per-page="pageMain.pageSize" :total-rows="pageMain.totalRows" @input="getOthersAnnoucments()" ></b-pagination>
                          </ul>
                      </div>
                  </div>
              </div> 
              <!-- Fin Pagination  -->
          </div>

      </div>


      <div class="card mt-md-2 mt-4 ml-md-0 ml-sm-2 ml-0 border border-info">
        <div class="card-body">
          <div class="mb-2">
            <h2 class="card-titl text-primary text-uppercase" style="font-size:20px;">
              Vos infos du jour
            </h2>
          </div>

          <hr class="mb-4" />

          <DailytInfo/>
        </div>
      </div>


    </div>

        <!-- QuickShortcuts -->
    <div class="col-md-4 col-sm-6 col-12 pl-lg-3 pl-md-3 mt-4 mt-md-0 mt-lg-0">

      <div class="card mb-2 border border-info">
        <div class="card-body">
          <div class="mb-2" >
            <h2 class="card-titl text-primary text-uppercase " style="font-size:20px; margin: 0;">
              Raccourcis rapides
            </h2>
          </div>
          <QuickShortcuts/>
        </div>
      </div>

      <div class="card mt-4 d-none d-md-block border border-info">
        <div class="card-body">
          <div class="mb-4">
            <h2 class="card-titl text-primary text-uppercase" style="font-size:20px;">
              Statistiques rapides
            </h2>
          </div>

          <hr class="mb-4" />

          <QuickStats/>
        </div>
      </div>



    </div>

    <div class="col-md-4 col-sm-6 col-12 pl-lg-3 pl-md-3 mt-4 mt-md-0 mt-lg-0 d-block d-md-none">

      <div class="card ml-md-0 ml-sm-2 ml-0">
        <div class="card-body">
          <div class="mb-2">
            <h2 class="card-titl text-primary text-uppercase" style="font-size:20px;">
              Statistiques rapides
            </h2>
          </div>

          <hr class="mb-4" />

          <QuickStats/>
        </div>
      </div>
    </div>

    </div>
<!-- End of Offers  in home page -->




  <b-modal v-if="this.selectedPromotion"
    v-model="showModal"
    class="modal-fullscreen"
    title="Details de l'offre"
    title-class=" text-primary"
    title-tag="h5"
    header-close-variant="danger"
    size="xl"
    full-screen
    no-close-on-esc
    hide-footer

    >
    <div class="zoom-container">
    <h3 class="text-center font-weight-bold">{{this.selectedPromotion.title}}
        <span
            class="badge ml-1"
            :class="{ 'badge-primary': `${this.selectedPromotion.type}` == 1,
                      'badge-warning': `${this.selectedPromotion.type}` == 0}"
          >{{this.selectedPromotion.type===0 ? 'Provisoire' :  'Permenante' }}</span>
    </h3>
    <h4 v-if="!this.selectedPromotion.formattedendDate" class="text-center text-dark">Offre valable a partir du <span class="text-success">{{this.selectedPromotion.formattedstartDate}}</span></h4>
    <h4 v-else class="text-center text-dark">Offre valable du <span class="text-success">{{this.selectedPromotion.formattedstartDate}}</span> au <span class="text-danger">{{this.selectedPromotion.formattedendDate}}</span></h4>
    <div  class="mt-4 border border-info" style="padding: 20px;margin: 10px">
      <h4 class="text-center">Description de l'offre</h4>
      <span  v-html="selectedPromotion.description" class="text-justify "> </span>
    </div>
    <div class="mt-4 border border-info font-size-14 text-justify text-center" style="padding: 20px;margin: 10px">
      <div v-if="this.selectedPromotion.suppliersOfferType===1 && this.selectedPromotion.minItemsNbre!=0">
        <span  class="m-2  font-size-16 font-weight-bold ">
          <i class=" fas fa-shopping-cart font-size-15 pr-2 text-primary"/>
          Nombre <span class="d-none d-sm-inline-block"> minimum </span> d'unités <span class="d-none d-sm-inline-block">panachables</span> :
        </span>
        
        <span class="text-warning font-size-16 font-weight-bold"> {{this.selectedPromotion.minItemsNbre}} </span><span class="font-size-16 d-none d-sm-inline-block ">  articles</span>
        <br>
      </div>

      <div v-if="this.selectedPromotion.suppliersOfferType===1">
        <span class="m-2  font-size-16 font-weight-bold ">
          <i class=" fas fa-coins font-size-15 pr-2 text-primary"/>
          Montant Minimal <span class="d-none d-sm-inline-block"> de commande (HT) </span>:
        </span>
        <span class="text-warning font-size-16 font-weight-bold"> {{this.selectedPromotion.minOrderValue}} </span><span class="font-size-16 d-none d-sm-inline-block ">  TND</span>
        <br>
      </div>

      <div v-if="this.selectedPromotion.suppliersOfferType===2">
        <span class="m-2  font-size-16 font-weight-bold ">
          <i class=" fas fa-coins font-size-15 pr-2 text-primary"/>
          <!-- Montant Minimal <span class="d-none d-sm-inline-block"> de commande Pharma (HT) </span>: -->
          Min commande Pharma (HT)
        </span>
        <span class="text-warning font-size-16 font-weight-bold"> {{this.selectedPromotion.minOrderValuePharma}} </span><span class="font-size-16 d-none d-sm-inline-block ">  TND</span>
        <br>
      </div>

      <div v-if="this.selectedPromotion.suppliersOfferType===2">
        <span class="m-2  font-size-16 font-weight-bold ">
          <i class=" fas fa-coins font-size-15 pr-2 text-primary"/>
          <!-- Montant Minimal <span class="d-none d-sm-inline-block"> de commande Para (HT) </span>: -->
          Min commande Para (HT)
        </span>
        <span class="text-warning font-size-16 font-weight-bold"> {{this.selectedPromotion.minOrderValuePara}} </span><span class="font-size-16 d-none d-sm-inline-block ">  TND</span>
      </div>

      <span v-if="this.selectedPromotion.suppliersOfferType===1 && this.selectedPromotion.rules != null && this.selectedPromotion.rules.length > 0" class="m-2 font-size-16 font-weight-bold ">
         <br/>
        <i class=" fas fa-star font-size-16 pr-2 text-primary"/>
        Remises par palier :
      </span>
      <br> 
      <div v-if="this.selectedPromotion.suppliersOfferType===1"> 
        <div v-for="rule in this.selectedPromotion.rules" :key="rule.id"  >
        <span class="m-2 font-size-16" ><span class="d-none d-sm-inline-block " ></span> Commande <span class="d-none d-sm-inline-block " > </span> <i class=" fas fa-greater-than font-size-14 pr-2 pl-2 text-primary"/>{{rule.minOrderValue}} <span class="text-muted font-size-12">(TND HT)</span></span><i class=" fas fa-arrow-right font-size-14 pr-2 pl-2 text-primary"/>
        <span class="font-size-16">Remise supplémentaire de <span class="text-warning font-weight-bold">{{rule.discount}} %</span></span>
        </div>
      </div>

      <div v-if="this.consolidatedPreOrderTotalQty != null && this.consolidatedPreOrderTotalQty > 0">
        <span  class="m-2  font-size-18">
          <i class=" fas fa-info-circle font-size-20 pr-2 text-success"/>
           <i v-if="this.selectedPromotion.isQtyTarget">Les membres du groupement ont <span class="font-weight-bold text-success font-size-18">déjà commandé {{this.consolidatedPreOrderTotalQty}} </span> unités panachées ! </i>
           <i v-else >La commande globale des membres du groupement est de <span class="font-weight-bold text-success font-size-18"> {{this.consolidatedPreOrderTotalQty}} TND</span> HT ! </i>
        </span>
        <br>
      </div>

    </div>

    <div class="pt-4 p-0 m-0" >
      <CatalogList v-if="this.selectedPromotion.isActiveAndDatesValid" :selectedSupplier=this.selectedPromotion.supplierId :selectedPromotion=this.selectedPromotion.id 
      :suppliersOfferType=this.selectedPromotion.suppliersOfferType :minOrderValuePara=selectedPromotion.minOrderValuePara :minOrderValuePharma=selectedPromotion.minOrderValuePharma
      :isCashPaymentMandatory=this.selectedPromotion.isCashPaymentMandetory v-on:update="updateOffers"
      :minItemsNbre="this.selectedPromotion.minItemsNbre"
 />

    </div>
    <div class="mt-4 p-2 border border-info font-size-16 text-justify" style="padding: 20px;margin: 10px">
      <div class="row p-2 ">
        <div class="col-sm-2">
          Période de l'offre:
        </div>
        <div class="col-sm-10">
          <span v-if="this.selectedPromotion.formattedendDate" class="text-primary font-weight-bold">Du {{this.selectedPromotion.formattedstartDate}} au {{this.selectedPromotion.formattedendDate}}</span>
          <span v-else class="text-primary font-weight-bold">Depuis {{this.selectedPromotion.formattedstartDate}}</span>

        </div>
      </div>
      <div class="row p-2 ">
        <div class="col-sm-2">
          Délai de Livraison:
        </div>
        <div class="col-sm-10">
          <span class="text-primary font-weight-bold">{{this.selectedPromotion.deliveryDays}} jours</span>
        </div>
      </div>
      <div class="row p-2 ">
        <div class="col-sm-2">
          Delai de paiement:
        </div>
        <div class="col-sm-10">
          <span class="text-primary font-weight-bold">{{this.selectedPromotion.paymentDays}} jours</span>
        </div>
      </div>
    </div>
    </div>
    </b-modal>





    <b-modal v-if="selectedExchange" v-model="showNewExchangeModal" 
    title="Details de l'Annonce" 
    centered 
    title-class="text-warning"
    title-tag="h5"
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    header-close-variant="danger">
        <template v-slot:modal-footer>
          <b-button class="zoom-container" variant="secondary" @click="closeNewExchangeModal()" size="md">Annuler</b-button>
          <b-button class="zoom-container" variant="primary" @click="saveAnnouncment()" size="md" >Publier l'annonce</b-button>
        </template>
        <div class="zoom-container">
        <b-form-group>
          <label class="pt-1 pb-1 font-weight-bold font-20">Produit <span class="text-danger mb-2" style="font-size:9px">(obligatoire)</span></label>
          <input
          type="text"
          class="form-control font-size-13 "
          v-model="selectedExchange.productTitle"
          />
        </b-form-group>

        <b-form-group>
          <label  class="pt-1 pb-1 font-weight-bold font-20">Date de Péremption</label>
          <input  v-mask="'##/####'" type="text" v-model="selectedExchange.expirationDate" class="form-control" placeholder="Entrer une date" />
        </b-form-group>

        <b-form-group>
          <label  class="pt-1 pb-1 font-weight-bold font-20">Description de l'annonce</label>
          <textarea
            v-model="selectedExchange.description"
            class="form-control"
            :maxlength="225"
            rows="4"
            placeholder="Limite de 225 caractéres."
          ></textarea>
          <div class="text-center">
            <p
              v-if="selectedExchange.description"
              class="badge position-absolute"
              :class="{ 'badge-success': selectedExchange.description.length !== 225,
                        'badge-danger': selectedExchange.description.length === 225 }"
            >
              {{ selectedExchange.description.length }} /
              225
            </p>
          </div>
        </b-form-group>

        <b-form-group>
          <label  class="pt-1 pb-1 font-weight-bold font-20">Prix :</label>
            <input v-model="selectedExchange.price" type="number"  class="form-control"  />
        </b-form-group>
<!-- v-model needs a boolean -->
        <!-- <b-form-checkbox v-model="selectedAnnouncment.stateForSwitch" switch class="mb-1 mt-4">
          <label>Publier cette Annonce</label>
        </b-form-checkbox> -->
      <!-- <button type="button" class="btn btn-primary float-right" @click="saveAnnouncment()" >Enregistrer</button> -->
        </div>
    </b-modal>


    <b-modal 
        size="md"
        full-screen
        hide-footer
        hide-header
        v-model="showExchangeModal"  
        v-if="this.selectedExchange">


                <div class="product-img position-relative">
                </div>
                <div class="mt-1  text-center">
                  <h5 class="mb-2 text-truncate font-size-18 ">
                    <span tag="a" class="text-dark" >{{this.selectedExchange.productTitle}}</span>
                  </h5>

                  <h5 class="mb-3 text-truncate font-size-12 badge badge-primary"><i class="fas fa-plus mr-2"/>{{this.selectedExchange.customerName}}</h5>
                </div>

                <div class="row mt-1 text-center">
                    <div class="col-12 ">
                      <span class="text-primary" style="text-align:justify"> 
                            <i v-if="this.selectedExchange.customerPhone" class="fas fa-phone  mr-2" />{{this.selectedExchange.customerPhone}}
                            <i v-if="this.selectedExchange.customerMail" class="fas fa-envelope ml-2 mr-2"/>{{this.selectedExchange.customerMail}}
                        </span>
                    </div>
                </div>

                <div class="row mt-1 mb-4 text-center">
                    <div v-if="this.selectedExchange.customerAddress" class="col-12">
                      <span class="text-primary" style="text-align:justify"> 
                            <i class="fas fa-map-marker  mr-2" />{{this.selectedExchange.customerAddress}}
                        </span>
                    </div>
                </div>
            
            <div class="row pt-2">
              <div class=col-6>
                <h5 class="font-size-15 text-secondary">Annonce</h5>
              </div>

              <div class=col-6>
                <h5 class="text-secondary font-size-12 pull-right text-right"><i>{{this.selectedExchange.formattedCreationDate}}</i></h5>
              </div>
            </div>
              

            <div  class="mb-1 border border-light" style="min-height:100px">
            <p class="text-dark p-2 font-weight-bold" style="text-align:justify">
              {{this.selectedExchange.description}}  </p>

            </div>

              <div class="row mt-3">
                  <div class="col-6 text-left pull-left">
                    <span class="mb-0 text-muted font-weight-bold">Date de Péremption</span>
                    <h5 class="font-size-14 mb-1 text-danger"><i class="far fa-calendar-check mr-2" title="Date de péremption" />{{this.selectedExchange.expirationDate ? this.selectedExchange.expirationDate : '___'}}</h5>
                    
                  </div>

                <div class="col-6 text-right pull-right">
                  <span class="mb-0 text-muted font-weight-bold">Prix HT</span>
                  <h5 class="font-size-15 mb-left1 text-success">{{this.selectedExchange.priceAsString}} TND</h5>
                </div>
                
              </div>
           
              </b-modal>

              <b-modal         
                size="xl"
                title="Promotion visible seulement aux officines ci-dessous"
                hide-footer
                v-model="showCustomersListModal" >

                <div class="table-responsive"  > 
                                <b-table 
                                
                                :striped="true"
                                :small="true"
                                :hover="true"
                                :items="customersInPromotionList"
                                :fields="customersInPromotionFields"
                               
                                class="table  "
                                thead-class="d-none"
                                id="customers-list-table"
                                >
                                    <template v-slot:table-busy>
                                        <div class="text-center my-2">
                                            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                                        </div>
                                    </template>

                                    <template v-slot:head(companyName)>
                                        Officine
                                    </template>
                                  
                                    <template v-slot:head(city)>
                                        {{ $t("traders.tradersCustomersModal.table.city") }} 
                                    </template>

                                    <template v-slot:head(address)>
                                        Adresse
                                    </template>

                                    
                                </b-table>
                        </div>
               

              </b-modal>


</div>
</template>

<style>
.modal-dialog.modal-xl {
    min-width: 95% !important;
}

</style>




<style>

.offer-card {
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 24px 16px;
  background: #fff;
  height: 100%;
  transition: all 0.3s ease;
}

.offer-card:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  transform: translateY(-4px);
}

/* LOGO */
.offer-logo {
  height: 120px;
  max-width: 140px;
  object-fit: contain;
  margin-bottom: 16px;
}

/* TITLE / BRAND */
.offer-name {
  font-size: 18px;
  margin-bottom: 8px;
  color: #000;
}

/* DESCRIPTION */
.offer-note {
  font-size: 18px;
  font-style: normal;
  color: #555;
  margin-bottom: 16px;
  letter-spacing: 1.2px;
}


/* DESCRIPTION */
.offer-date {
  font-size: 18px;
  font-style: normal;
  color: #555;
  margin-bottom: 16px;
  letter-spacing: 1.2px;
}

.offer-card {
  position: relative;
}

/* Base badge */
.offer-badge {
  position: absolute;
  top: 12px;
  left: 12px;

  padding: 3px 6px;
  font-size: 10px;
  font-weight: 400;

  border-radius: 8px;
  color: #fff;

  z-index: 2;
}

/* Base badge */
.offer-type-badge {
  position: absolute;
  top: 12px;
  right: 12px;

  padding: 3px 6px;
  font-size: 10px;
  font-weight: 400;

  border-radius: 8px;
  color: #fff;

  z-index: 2;
}


</style>


